import { Action } from 'redux'

import ClientSSRInterface from '../../interfaces/client/SSR'

import { V1_RECEIVE_SSR_LIST } from '../../actions/ssrs/v1receiveSSRList'
import { ADD_PASSENGER_SSR } from '../../actions/passengers/addPassengerSSR'
import { REMOVE_PASSENGER_SSR } from '../../actions/passengers/removePassengerSSR'

import normalizeData from '../../utils/normalizeData'

export interface SSRsState {
  byId: {
    [id: string]: ClientSSRInterface
  }
  allIds: string[]
}

export interface SSRAction extends Action {
  data: ClientSSRInterface[]
  ssrId: string
  passengerSSRId: string
}

export const initialState: SSRsState = {
  byId: {},
  allIds: [],
}

export default (
  state = initialState,
  action: SSRAction = { type: '', data: [], ssrId: '', passengerSSRId: '' }
) => {
  switch (action.type) {
    case V1_RECEIVE_SSR_LIST:
      const receiveSSRsIds = action.data.map(
        (SSR: ClientSSRInterface) => SSR.id
      )

      return {
        ...state,
        byId: normalizeData(action.data),
        allIds: receiveSSRsIds,
      }

    case ADD_PASSENGER_SSR: {
      const ssrId = action.ssrId
      const ssrToChange = state.byId[ssrId]

      if (!ssrToChange) {
        return state
      } // action is triggered on edit passengers page

      if (ssrToChange.isLimited && ssrToChange.availableCount) {
        ssrToChange.availableCount--
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [ssrId]: ssrToChange,
        },
      }
    }

    case REMOVE_PASSENGER_SSR: {
      const ssrId = action.passengerSSRId.split('-')
      const ssrToChange = state.byId[ssrId[0]]

      if (ssrToChange.isLimited && ssrToChange.availableCount !== undefined) {
        ssrToChange.availableCount++
      }

      return {
        ...state,
        byId: {
          ...state.byId,
          [ssrId[0]]: ssrToChange,
        },
      }
    }

    case '@@router/LOCATION_CHANGE':
      return initialState

    default:
      return state
  }
}
